export default "__VITE_ASSET__414c1c23__"